import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../home/components/Footer';

export default function PaymentPage() {
  const navigate = useNavigate();

  const handleBookingClick = () => {
    navigate('/', { replace: false });
    setTimeout(() => {
      document.getElementById('booking')?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="text-2xl font-bold text-gray-800" style={{ fontFamily: "'Klee One', cursive" }}>
            こころケア
          </Link>
          
          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className="text-gray-700 hover:text-gray-900 transition-colors text-sm">ホーム</Link>
            <Link to="/profile" className="text-gray-700 hover:text-gray-900 transition-colors text-sm">自己紹介</Link>
            <Link to="/terms" className="text-gray-700 hover:text-gray-900 transition-colors text-sm">注意事項</Link>
            <Link to="/faq" className="text-gray-700 hover:text-gray-900 transition-colors text-sm">よくある質問</Link>
          </div>

          <button 
            onClick={handleBookingClick}
            className="bg-[#FF9B8A] hover:bg-[#FF8A77] text-white px-6 py-2.5 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer"
          >
            今すぐ予約
          </button>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="pt-32 pb-16 px-6 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#FFF5F3] via-white to-[#F0F9FF]"></div>
        
        <div className="max-w-4xl mx-auto relative z-10 text-center">
          <div className="inline-block px-4 py-2 bg-[#FF9B8A]/10 rounded-full mb-6">
            <span className="text-[#FF9B8A] text-sm font-medium">Payment Methods</span>
          </div>
          
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Klee One', cursive" }}>
            お支払い方法
          </h1>
          
          <p className="text-lg text-gray-600">
            3つの方法からお選びいただけます
          </p>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="py-16 px-6 bg-white">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-block px-4 py-2 bg-[#FF9B8A]/10 rounded-full mb-6">
              <span className="text-[#FF9B8A] text-sm font-medium">料金</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Klee One', cursive" }}>
              料金について
            </h2>
          </div>

          <div className="bg-gradient-to-br from-[#FFF5F3] to-[#F0F9FF] rounded-3xl p-10 text-center border-2 border-[#FF9B8A]/20 mb-12">
            <p className="text-gray-600 mb-4">1回のセッション</p>
            <div className="flex items-center justify-center gap-4 mb-6">
              <div>
                <p className="text-5xl md:text-6xl font-bold text-[#FF9B8A]">¥3,000</p>
                <p className="text-gray-600 mt-2">40分</p>
              </div>
            </div>
            <p className="text-sm text-gray-600">
              ※ 予約時に事前決済となります
            </p>
          </div>

          {/* NEW: Why This Price Section */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border-2 border-gray-100 mb-12">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-12 h-12 bg-[#FFD93D]/20 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-question-line text-[#FF9B8A] text-2xl w-6 h-6 flex items-center justify-center"></i>
              </div>
              <div className="flex-1">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">なぜこの価格で提供できるのか？</h3>
                
                <div className="space-y-4 text-gray-700 leading-relaxed">
                  <p>
                    私自身が若い頃に悩みを抱えていた時、<strong className="text-[#FF9B8A]">「こんなサービスがあったらいいのに」</strong>と心から思っていました。
                  </p>
                  
                  <p>
                    本サービスは、<strong className="text-[#FF9B8A]">心理学を学ぶ大学生</strong>が、同じような悩みを抱える若い世代の方々のために立ち上げたサポートサービスです。
                  </p>
                  
                  <div className="bg-blue-50 border-2 border-blue-200 rounded-xl p-5">
                    <h4 className="font-bold text-blue-900 mb-3 flex items-center gap-2">
                      <i className="ri-heart-3-line text-xl w-5 h-5 flex items-center justify-center"></i>
                      若い世代だからこそできること
                    </h4>
                    <ul className="space-y-2 text-sm text-blue-800">
                      <li className="flex items-start gap-2">
                        <span className="text-blue-500 mt-1">•</span>
                        <span><strong>身近な目線</strong>で、同世代だからこそ分かり合える感覚</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="text-blue-500 mt-1">•</span>
                        <span><strong>気軽に話せる雰囲気</strong>で、硬くなりがちな相談を自然な会話に</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="text-blue-500 mt-1">•</span>
                        <span><strong>現代の悩みに共感</strong>しながら、一緒に考えていけること</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="text-blue-500 mt-1">•</span>
                        <span><strong>手が届きやすい料金</strong>で、必要な時にすぐ利用できること</span>
                      </li>
                    </ul>
                  </div>

                  <p>
                    もちろん、私たちはまだ学習中の身です。専門的な治療や診断は行えません。でも、<strong className="text-[#FF9B8A]">「話を聞いてもらいたい」「共感してもらいたい」</strong>という気持ちに寄り添うことはできます。
                  </p>

                  <div className="bg-red-50 border-2 border-red-200 rounded-xl p-5">
                    <h4 className="font-bold text-red-900 mb-3 flex items-center gap-2">
                      <i className="ri-alert-line text-xl w-5 h-5 flex items-center justify-center"></i>
                      ただし、以下のケースは承れません
                    </h4>
                    <ul className="space-y-2 text-sm text-red-800">
                      <li className="flex items-start gap-2">
                        <span className="text-red-500 mt-1">•</span>
                        <span><strong>自殺念慮や自傷行為</strong>の具体的計画がある場合</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="text-red-500 mt-1">•</span>
                        <span><strong>他害のおそれ</strong>がある場合</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="text-red-500 mt-1">•</span>
                        <span><strong>虐待</strong>が疑われる場合</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="text-red-500 mt-1">•</span>
                        <span><strong>精神疾患の診断</strong>を受けている場合</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="text-red-500 mt-1">•</span>
                        <span><strong>医学的治療</strong>が必要な症状がある場合</span>
                      </li>
                    </ul>
                    <p className="text-sm text-red-800 mt-3 font-medium">
                      → これらの場合は、医療機関や専門機関への受診をお勧めします。
                    </p>
                  </div>

                  <p className="text-sm text-gray-600 mt-4">
                    本サービスは<strong>医療行為ではありません</strong>。日常的な悩みや心のケアを目的とした、気軽に相談できるサポートサービスです。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Payment Methods */}
      <section className="py-16 px-6 bg-white">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Klee One', cursive" }}>
              お支払い方法
            </h2>
            <p className="text-gray-600">
              予約時にクレジットカードで事前決済
            </p>
          </div>

          <div className="space-y-6">
            {/* Credit Card - Now Primary */}
            <div className="bg-gradient-to-br from-purple-50 to-white rounded-3xl p-8 border-2 border-purple-200 shadow-lg">
              <div className="flex flex-col md:flex-row items-start gap-6">
                <div className="flex-shrink-0">
                  <div className="w-20 h-20 bg-gradient-to-br from-purple-500 to-purple-600 rounded-2xl flex items-center justify-center shadow-lg">
                    <i className="ri-bank-card-line text-white text-3xl w-8 h-8 flex items-center justify-center"></i>
                  </div>
                </div>

                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-3">
                    <h3 className="text-2xl font-bold text-gray-900" style={{ fontFamily: "'Klee One', cursive" }}>
                      クレジットカード
                    </h3>
                    <span className="px-3 py-1 bg-purple-100 text-purple-700 text-xs font-bold rounded-full">事前決済</span>
                  </div>
                  
                  <p className="text-gray-700 mb-4 leading-relaxed">
                    VISA、Mastercard、JCB、American Expressがご利用いただけます
                  </p>

                  <div className="bg-white rounded-xl p-5 border border-purple-200 mb-4">
                    <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                      <i className="ri-information-line text-purple-500 text-lg w-5 h-5 flex items-center justify-center"></i>
                      お支払いの流れ
                    </h4>
                    <ol className="space-y-2 text-sm text-gray-700">
                      <li className="flex items-start gap-2">
                        <span className="flex-shrink-0 w-6 h-6 bg-purple-100 text-purple-700 rounded-full flex items-center justify-center text-xs font-bold">1</span>
                        <span>予約フォームを送信</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="flex-shrink-0 w-6 h-6 bg-purple-100 text-purple-700 rounded-full flex items-center justify-center text-xs font-bold">2</span>
                        <span>自動的にクレジットカード決済ページへ移動</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="flex-shrink-0 w-6 h-6 bg-purple-100 text-purple-700 rounded-full flex items-center justify-center text-xs font-bold">3</span>
                        <span>カード情報を入力して決済完了</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="flex-shrink-0 w-6 h-6 bg-purple-100 text-purple-700 rounded-full flex items-center justify-center text-xs font-bold">4</span>
                        <span>決済完了後、予約が確定します</span>
                      </li>
                    </ol>
                  </div>

                  <div className="bg-purple-50 rounded-xl p-4 border border-purple-200">
                    <h4 className="font-bold text-purple-900 mb-2 text-sm">安心・安全な決済</h4>
                    <ul className="space-y-1 text-xs text-purple-800">
                      <li>• SSL暗号化通信で情報を保護</li>
                      <li>• カード情報は当サービスに保存されません</li>
                      <li>• 決済完了後すぐに領収書が発行されます</li>
                    </ul>
                  </div>

                  <div className="flex items-center gap-3 mt-4">
                    <i className="ri-visa-line text-3xl text-gray-600 w-8 h-8 flex items-center justify-center"></i>
                    <i className="ri-mastercard-line text-3xl text-gray-600 w-8 h-8 flex items-center justify-center"></i>
                    <span className="text-sm font-medium text-gray-600">JCB</span>
                    <span className="text-sm font-medium text-gray-600">AMEX</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Note about other payment methods */}
          <div className="mt-8 bg-blue-50 rounded-2xl p-6 border-2 border-blue-200">
            <div className="flex items-start gap-4">
              <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-information-line text-blue-600 text-xl w-5 h-5 flex items-center justify-center"></i>
              </div>
              <div>
                <h4 className="font-bold text-blue-900 mb-2">その他のお支払い方法について</h4>
                <p className="text-sm text-blue-800 leading-relaxed">
                  クレジットカードをお持ちでない方は、PayPayや銀行振込でのお支払いも可能です。<br />
                  ご希望の場合は、予約フォームの「メッセージ」欄に「PayPay希望」または「銀行振込希望」とご記入ください。<br />
                  別途、お支払い方法のご案内をメールでお送りします。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Payment Timing */}
      <section className="py-16 px-6 bg-gradient-to-br from-[#FFF5F3] to-[#F0F9FF]">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-3xl p-8 md:p-10 shadow-lg border-2 border-[#FF9B8A]/20">
            <div className="text-center mb-8">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-[#FF9B8A] rounded-full mb-4">
                <i className="ri-time-line text-white text-3xl w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h2 className="text-3xl font-bold text-gray-900 mb-3" style={{ fontFamily: "'Klee One', cursive" }}>
                お支払いのタイミング
              </h2>
            </div>

            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 bg-[#FF9B8A]/10 rounded-full flex items-center justify-center">
                  <i className="ri-calendar-check-line text-[#FF9B8A] text-xl w-5 h-5 flex items-center justify-center"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">予約時に事前決済</h3>
                  <p className="text-sm text-gray-700 leading-relaxed">
                    予約フォームを送信すると、自動的にクレジットカード決済ページへ移動します。決済が完了すると、予約が確定します。
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 bg-[#FF9B8A]/10 rounded-full flex items-center justify-center">
                  <i className="ri-shield-check-line text-[#FF9B8A] text-xl w-5 h-5 flex items-center justify-center"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">安心の事前決済</h3>
                  <p className="text-sm text-gray-700 leading-relaxed">
                    事前決済により、<strong className="text-[#FF9B8A]">セッション後のお支払い手続きが不要</strong>になります。セッションに集中していただけます。
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 bg-[#FF9B8A]/10 rounded-full flex items-center justify-center">
                  <i className="ri-mail-check-line text-[#FF9B8A] text-xl w-5 h-5 flex items-center justify-center"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">決済完了後の確認</h3>
                  <p className="text-sm text-gray-700 leading-relaxed">
                    決済完了後、予約確定メールとGoogle Meetのリンクをお送りします。領収書も同時に発行されます。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Refund Policy */}
      <section className="py-16 px-6 bg-white">
        <div className="max-w-4xl mx-auto">
          <div className="bg-yellow-50 rounded-3xl p-8 md:p-10 border-2 border-yellow-200">
            <div className="flex items-start gap-4 mb-6">
              <div className="flex-shrink-0 w-12 h-12 bg-yellow-500 rounded-full flex items-center justify-center">
                <i className="ri-alert-line text-white text-2xl w-6 h-6 flex items-center justify-center"></i>
              </div>
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Klee One', cursive" }}>
                  キャンセル・返金について
                </h2>
              </div>
            </div>

            <div className="space-y-4 text-gray-700">
              <div className="bg-white rounded-xl p-5 border border-yellow-200">
                <h3 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
                  <i className="ri-checkbox-circle-line text-green-500 text-lg w-5 h-5 flex items-center justify-center"></i>
                  全額返金の場合
                </h3>
                <p className="text-sm leading-relaxed">
                  <strong>セッション開始の24時間前まで</strong>にキャンセルのご連絡をいただいた場合、全額返金いたします。
                </p>
              </div>

              <div className="bg-white rounded-xl p-5 border border-yellow-200">
                <h3 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
                  <i className="ri-error-warning-line text-orange-500 text-lg w-5 h-5 flex items-center justify-center"></i>
                  50%返金の場合
                </h3>
                <p className="text-sm leading-relaxed mb-2">
                  <strong>セッション開始24時間前を過ぎてから</strong>のキャンセルの場合、50%（1,500円）を返金いたします。
                </p>
                <p className="text-xs text-gray-600">
                  ※ キャンセル料として50%（1,500円）をいただきます
                </p>
              </div>

              <div className="bg-white rounded-xl p-5 border border-yellow-200">
                <h3 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
                  <i className="ri-close-circle-line text-red-500 text-lg w-5 h-5 flex items-center justify-center"></i>
                  返金できない場合
                </h3>
                <ul className="text-sm space-y-1">
                  <li>• 無断キャンセル（全額キャンセル料）</li>
                  <li>• セッション開始後のキャンセル</li>
                </ul>
              </div>

              <p className="text-sm text-gray-600 mt-4">
                ※ 返金には3〜5営業日かかる場合があります<br />
                ※ 振込手数料はご負担いただく場合があります
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Link */}
      <section className="py-16 px-6 bg-gradient-to-br from-[#FFF5F3] to-[#F0F9FF]">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-[#FF9B8A] rounded-full mb-6">
            <i className="ri-question-line text-white text-3xl w-8 h-8 flex items-center justify-center"></i>
          </div>
          
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Klee One', cursive" }}>
            お支払いについて不安がありますか？
          </h2>
          
          <p className="text-lg text-gray-600 mb-8">
            よくある質問ページで詳しく解説しています
          </p>

          <Link
            to="/faq"
            className="inline-block bg-gradient-to-r from-[#FF9B8A] to-[#FFD93D] hover:from-[#FF8A77] hover:to-[#FFC82D] text-white px-10 py-4 rounded-full text-base font-bold transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            よくある質問を見る
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
